import { StaticImageData } from "next/image";
import aave from "./aave.svg";
import abt from "./abt.svg";
import act from "./act.svg";
import actn from "./actn.svg";
import ada from "./ada.svg";
import add from "./add.svg";
import adx from "./adx.svg";
import ae from "./ae.svg";
import aeon from "./aeon.svg";
import aeur from "./aeur.svg";
import agi from "./agi.svg";
import agrs from "./agrs.svg";
import aion from "./aion.svg";
import algo from "./algo.svg";
import amb from "./amb.svg";
import amp from "./amp.svg";
import ampl from "./ampl.svg";
import ankr from "./ankr.svg";
import ant from "./ant.svg";
import ape from "./ape.svg";
import apex from "./apex.svg";
import appc from "./appc.svg";
import ardr from "./ardr.svg";
import arg from "./arg.svg";
import ark from "./ark.svg";
import arn from "./arn.svg";
import arnx from "./arnx.svg";
import ary from "./ary.svg";
import ast from "./ast.svg";
import atlas from "./atlas.svg";
import atm from "./atm.svg";
import atom from "./atom.svg";
import audr from "./audr.svg";
import aury from "./aury.svg";
import auto from "./auto.svg";
import avax from "./avax.svg";
import aywa from "./aywa.svg";
import bab from "./bab.svg";
import bal from "./bal.svg";
import band from "./band.svg";
import bat from "./bat.svg";
import bay from "./bay.svg";
import bcbc from "./bcbc.svg";
import bcc from "./bcc.svg";
import bcd from "./bcd.svg";
import bch from "./bch.svg";
import bcio from "./bcio.svg";
import bcn from "./bcn.svg";
import bco from "./bco.svg";
import bcpt from "./bcpt.svg";
import bdl from "./bdl.svg";
import beam from "./beam.svg";
import bela from "./bela.svg";
import bix from "./bix.svg";
import blcn from "./blcn.svg";
import blk from "./blk.svg";
import block from "./block.svg";
import blz from "./blz.svg";
import bnb from "./bnb.svg";
import bnt from "./bnt.svg";
import bnty from "./bnty.svg";
import booty from "./booty.svg";
import bos from "./bos.svg";
import bpt from "./bpt.svg";
import bq from "./bq.svg";
import brd from "./brd.svg";
import bsd from "./bsd.svg";
import bsv from "./bsv.svg";
import btc from "./btc.svg";
import btcd from "./btcd.svg";
import btch from "./btch.svg";
import btcp from "./btcp.svg";
import btcz from "./btcz.svg";
import btdx from "./btdx.svg";
import btg from "./btg.svg";
import btm from "./btm.svg";
import bts from "./bts.svg";
import btt from "./btt.svg";
import btx from "./btx.svg";
import burst from "./burst.svg";
import bze from "./bze.svg";
import call from "./call.svg";
import cc from "./cc.svg";
import cdn from "./cdn.svg";
import cdt from "./cdt.svg";
import cenz from "./cenz.svg";
import chain from "./chain.svg";
import chat from "./chat.svg";
import chips from "./chips.svg";
import chsb from "./chsb.svg";
import chz from "./chz.svg";
import cix from "./cix.svg";
import clam from "./clam.svg";
import cloak from "./cloak.svg";
import cmm from "./cmm.svg";
import cmt from "./cmt.svg";
import cnd from "./cnd.svg";
import cnx from "./cnx.svg";
import cny from "./cny.svg";
import cob from "./cob.svg";
import colx from "./colx.svg";
import comp from "./comp.svg";
import coqui from "./coqui.svg";
import cred from "./cred.svg";
import crpt from "./crpt.svg";
import crv from "./crv.svg";
import crw from "./crw.svg";
import cs from "./cs.svg";
import ctr from "./ctr.svg";
import ctxc from "./ctxc.svg";
import cvc from "./cvc.svg";
import d from "./d.svg";
import dai from "./dai.svg";
import dash from "./dash.svg";
import dat from "./dat.svg";
import data from "./data.svg";
import dbc from "./dbc.svg";
import dcn from "./dcn.svg";
import dcr from "./dcr.svg";
import deez from "./deez.svg";
import dent from "./dent.svg";
import dew from "./dew.svg";
import dgb from "./dgb.svg";
import dgd from "./dgd.svg";
import dlt from "./dlt.svg";
import dnt from "./dnt.svg";
import dock from "./dock.svg";
import doge from "./doge.svg";
import dot from "./dot.svg";
import drgn from "./drgn.svg";
import drop from "./drop.svg";
import dta from "./dta.svg";
import dth from "./dth.svg";
import dtr from "./dtr.svg";
import ebst from "./ebst.svg";
import eca from "./eca.svg";
import edg from "./edg.svg";
import edo from "./edo.svg";
import edoge from "./edoge.svg";
import ela from "./ela.svg";
import elec from "./elec.svg";
import elf from "./elf.svg";
import elix from "./elix.svg";
import ella from "./ella.svg";
import emb from "./emb.svg";
import emc from "./emc.svg";
import emc2 from "./emc2.svg";
import eng from "./eng.svg";
import enj from "./enj.svg";
import entrp from "./entrp.svg";
import eon from "./eon.svg";
import eop from "./eop.svg";
import eos from "./eos.svg";
import eqli from "./eqli.svg";
import equa from "./equa.svg";
import etc from "./etc.svg";
import eth from "./eth.svg";
import ethos from "./ethos.svg";
import etn from "./etn.svg";
import etp from "./etp.svg";
import eur from "./eur.svg";
import evx from "./evx.svg";
import exmo from "./exmo.svg";
import exp from "./exp.svg";
import fair from "./fair.svg";
import fct from "./fct.svg";
import fida from "./fida.svg";
import fil from "./fil.svg";
import fjc from "./fjc.svg";
import fldc from "./fldc.svg";
import flo from "./flo.svg";
import flux from "./flux.svg";
import fsn from "./fsn.svg";
import ftc from "./ftc.svg";
import fuel from "./fuel.svg";
import fun from "./fun.svg";
import game from "./game.svg";
import gas from "./gas.svg";
import gbp from "./gbp.svg";
import gbx from "./gbx.svg";
import gbyte from "./gbyte.svg";
import generic from "./generic.svg";
import gin from "./gin.svg";
import glxt from "./glxt.svg";
import gmr from "./gmr.svg";
import gmt from "./gmt.svg";
import gno from "./gno.svg";
import gnt from "./gnt.svg";
import gold from "./gold.svg";
import grc from "./grc.svg";
import grin from "./grin.svg";
import grs from "./grs.svg";
import grt from "./grt.svg";
import gsc from "./gsc.svg";
import gto from "./gto.svg";
import gup from "./gup.svg";
import gusd from "./gusd.svg";
import gvt from "./gvt.svg";
import gxs from "./gxs.svg";
import gzr from "./gzr.svg";
import hight from "./hight.svg";
import hns from "./hns.svg";
import hodl from "./hodl.svg";
import hot from "./hot.svg";
import hpb from "./hpb.svg";
import hsr from "./hsr.svg";
import ht from "./ht.svg";
import html from "./html.svg";
import huc from "./huc.svg";
import husd from "./husd.svg";
import hush from "./hush.svg";
import icn from "./icn.svg";
import icp from "./icp.svg";
import icx from "./icx.svg";
import ignis from "./ignis.svg";
import ilk from "./ilk.svg";
import ink from "./ink.svg";
import ins from "./ins.svg";
import ion from "./ion.svg";
import iop from "./iop.svg";
import iost from "./iost.svg";
import iotx from "./iotx.svg";
import iq from "./iq.svg";
import itc from "./itc.svg";
import jnt from "./jnt.svg";
import jpy from "./jpy.svg";
import kcs from "./kcs.svg";
import kin from "./kin.svg";
import klown from "./klown.svg";
import kmd from "./kmd.svg";
import knc from "./knc.svg";
import krb from "./krb.svg";
import ksm from "./ksm.svg";
import lbc from "./lbc.svg";
import lend from "./lend.svg";
import leo from "./leo.svg";
import link from "./link.svg";
import lkk from "./lkk.svg";
import loom from "./loom.svg";
import lpt from "./lpt.svg";
import lrc from "./lrc.svg";
import lsk from "./lsk.svg";
import ltc from "./ltc.svg";
import lun from "./lun.svg";
import maid from "./maid.svg";
import mana from "./mana.svg";
import matic from "./matic.svg";
import max from "./max.svg";
import mcap from "./mcap.svg";
import mco from "./mco.svg";
import mda from "./mda.svg";
import mds from "./mds.svg";
import med from "./med.svg";
import meetone from "./meetone.svg";
import mft from "./mft.svg";
import miota from "./miota.svg";
import mith from "./mith.svg";
import mkr from "./mkr.svg";
import mln from "./mln.svg";
import mnx from "./mnx.svg";
import mnz from "./mnz.svg";
import moac from "./moac.svg";
import mod from "./mod.svg";
import mona from "./mona.svg";
import msr from "./msr.svg";
import mth from "./mth.svg";
import mtl from "./mtl.svg";
import music from "./music.svg";
import mzc from "./mzc.svg";
import nano from "./nano.svg";
import nas from "./nas.svg";
import nav from "./nav.svg";
import ncash from "./ncash.svg";
import ndz from "./ndz.svg";
import nebl from "./nebl.svg";
import neo from "./neo.svg";
import neos from "./neos.svg";
import neu from "./neu.svg";
import nexo from "./nexo.svg";
import ngc from "./ngc.svg";
import nio from "./nio.svg";
import nkn from "./nkn.svg";
import nlc2 from "./nlc2.svg";
import nlg from "./nlg.svg";
import nmc from "./nmc.svg";
import nmr from "./nmr.svg";
import npxs from "./npxs.svg";
import ntbc from "./ntbc.svg";
import nuls from "./nuls.svg";
import nxs from "./nxs.svg";
import nxt from "./nxt.svg";
import oax from "./oax.svg";
import ok from "./ok.svg";
import omg from "./omg.svg";
import omni from "./omni.svg";
import one from "./one.svg";
import ong from "./ong.svg";
import ont from "./ont.svg";
import oot from "./oot.svg";
import ost from "./ost.svg";
import ox from "./ox.svg";
import oxt from "./oxt.svg";
import oxy from "./oxy.svg";
import part from "./part.svg";
import pasc from "./pasc.svg";
import pasl from "./pasl.svg";
import pax from "./pax.svg";
import paxg from "./paxg.svg";
import pay from "./pay.svg";
import payx from "./payx.svg";
import pink from "./pink.svg";
import pirl from "./pirl.svg";
import pivx from "./pivx.svg";
import plr from "./plr.svg";
import poa from "./poa.svg";
import poe from "./poe.svg";
import polis from "./polis.svg";
import poly from "./poly.svg";
import pot from "./pot.svg";
import powr from "./powr.svg";
import ppc from "./ppc.svg";
import ppp from "./ppp.svg";
import ppt from "./ppt.svg";
import pre from "./pre.svg";
import prl from "./prl.svg";
import pungo from "./pungo.svg";
import pura from "./pura.svg";
import qash from "./qash.svg";
import qiwi from "./qiwi.svg";
import qlc from "./qlc.svg";
import qnt from "./qnt.svg";
import qrl from "./qrl.svg";
import qsp from "./qsp.svg";
import qtum from "./qtum.svg";
import r from "./r.svg";
import rads from "./rads.svg";
import rap from "./rap.svg";
import ray from "./ray.svg";
import rcn from "./rcn.svg";
import rdd from "./rdd.svg";
import rdn from "./rdn.svg";
import ren from "./ren.svg";
import rep from "./rep.svg";
import repv2 from "./repv2.svg";
import req from "./req.svg";
import rhoc from "./rhoc.svg";
import ric from "./ric.svg";
import rise from "./rise.svg";
import rlc from "./rlc.svg";
import rpx from "./rpx.svg";
import rub from "./rub.svg";
import rvn from "./rvn.svg";
import ryo from "./ryo.svg";
import safe from "./safe.svg";
import safemoon from "./safemoon.svg";
import sai from "./sai.svg";
import salt from "./salt.svg";
import san from "./san.svg";
import sand from "./sand.svg";
import sbd from "./sbd.svg";
import sberbank from "./sberbank.svg";
import sc from "./sc.svg";
import ser from "./ser.svg";
import shift from "./shift.svg";
import sib from "./sib.svg";
import sin from "./sin.svg";
import skl from "./skl.svg";
import sky from "./sky.svg";
import slr from "./slr.svg";
import sls from "./sls.svg";
import smart from "./smart.svg";
import sngls from "./sngls.svg";
import snm from "./snm.svg";
import snt from "./snt.svg";
import snx from "./snx.svg";
import soc from "./soc.svg";
import sol from "./sol.svg";
import spacehbit from "./spacehbit.svg";
import spank from "./spank.svg";
import sphtx from "./sphtx.svg";
import srn from "./srn.svg";
import stak from "./stak.svg";
import start from "./start.svg";
import steem from "./steem.svg";
import storj from "./storj.svg";
import storm from "./storm.svg";
import stox from "./stox.svg";
import stq from "./stq.svg";
import strat from "./strat.svg";
import stx from "./stx.svg";
import sub from "./sub.svg";
import sumo from "./sumo.svg";
import sushi from "./sushi.svg";
import sys from "./sys.svg";
import taas from "./taas.svg";
import tau from "./tau.svg";
import tbx from "./tbx.svg";
import tel from "./tel.svg";
import ten from "./ten.svg";
import tern from "./tern.svg";
import tgch from "./tgch.svg";
import theta from "./theta.svg";
import tix from "./tix.svg";
import tkn from "./tkn.svg";
import tks from "./tks.svg";
import tnb from "./tnb.svg";
import tnc from "./tnc.svg";
import tnt from "./tnt.svg";
import tomo from "./tomo.svg";
import tpay from "./tpay.svg";
import trig from "./trig.svg";
import trtl from "./trtl.svg";
import trx from "./trx.svg";
import tusd from "./tusd.svg";
import tzc from "./tzc.svg";
import ubq from "./ubq.svg";
import uma from "./uma.svg";
import uni from "./uni.svg";
import unity from "./unity.svg";
import usd from "./usd.svg";
import usdc from "./usdc.svg";
import usdt from "./usdt.svg";
import utk from "./utk.svg";
import veri from "./veri.svg";
import vet from "./vet.svg";
import via from "./via.svg";
import vib from "./vib.svg";
import vibe from "./vibe.svg";
import vivo from "./vivo.svg";
import vrc from "./vrc.svg";
import vrsc from "./vrsc.svg";
import vtc from "./vtc.svg";
import vtho from "./vtho.svg";
import wabi from "./wabi.svg";
import wan from "./wan.svg";
import waves from "./waves.svg";
import wax from "./wax.svg";
import wbtc from "./wbtc.svg";
import wgr from "./wgr.svg";
import wicc from "./wicc.svg";
import wings from "./wings.svg";
import wpr from "./wpr.svg";
import wtc from "./wtc.svg";
import x from "./x.svg";
import xas from "./xas.svg";
import xbc from "./xbc.svg";
import xbp from "./xbp.svg";
import xby from "./xby.svg";
import xcp from "./xcp.svg";
import xdn from "./xdn.svg";
import xem from "./xem.svg";
import xin from "./xin.svg";
import xlm from "./xlm.svg";
import xmcc from "./xmcc.svg";
import xmg from "./xmg.svg";
import xmo from "./xmo.svg";
import xmr from "./xmr.svg";
import xmy from "./xmy.svg";
import xp from "./xp.svg";
import xpa from "./xpa.svg";
import xpm from "./xpm.svg";
import xpr from "./xpr.svg";
import xrp from "./xrp.svg";
import xsg from "./xsg.svg";
import xtz from "./xtz.svg";
import xuc from "./xuc.svg";
import xvc from "./xvc.svg";
import xvg from "./xvg.svg";
import xzc from "./xzc.svg";
import yfi from "./yfi.svg";
import yoyow from "./yoyow.svg";
import zcl from "./zcl.svg";
import zec from "./zec.svg";
import zel from "./zel.svg";
import zen from "./zen.svg";
import zest from "./zest.svg";
import zil from "./zil.svg";
import zilla from "./zilla.svg";
import zrx from "./zrx.svg";
//
import azn from "./azn.png";
import kzt from "./kzt.png";
import mdl from "./mdl.png";
import uzs from "./uzs.png";



export const crypto_images: { [key: string]: string | StaticImageData } = {
    aave: aave,
    abt: abt,
    act: act,
    actn: actn,
    ada: ada,
    add: add,
    adx: adx,
    ae: ae,
    aeon: aeon,
    aeur: aeur,
    agi: agi,
    agrs: agrs,
    aion: aion,
    algo: algo,
    amb: amb,
    amp: amp,
    ampl: ampl,
    ankr: ankr,
    ant: ant,
    ape: ape,
    apex: apex,
    appc: appc,
    ardr: ardr,
    arg: arg,
    ark: ark,
    arn: arn,
    arnx: arnx,
    ary: ary,
    ast: ast,
    atlas: atlas,
    atm: atm,
    atom: atom,
    audr: audr,
    aury: aury,
    auto: auto,
    avax: avax,
    aywa: aywa,
    bab: bab,
    bal: bal,
    band: band,
    bat: bat,
    bay: bay,
    bcbc: bcbc,
    bcc: bcc,
    bcd: bcd,
    bch: bch,
    bcio: bcio,
    bcn: bcn,
    bco: bco,
    bcpt: bcpt,
    bdl: bdl,
    beam: beam,
    bela: bela,
    bix: bix,
    blcn: blcn,
    blk: blk,
    block: block,
    blz: blz,
    bnb: bnb,
    bnt: bnt,
    bnty: bnty,
    booty: booty,
    bos: bos,
    bpt: bpt,
    bq: bq,
    brd: brd,
    bsd: bsd,
    bsv: bsv,
    btc: btc,
    btcd: btcd,
    btch: btch,
    btcp: btcp,
    btcz: btcz,
    btdx: btdx,
    btg: btg,
    btm: btm,
    bts: bts,
    btt: btt,
    btx: btx,
    burst: burst,
    bze: bze,
    call: call,
    cc: cc,
    cdn: cdn,
    cdt: cdt,
    cenz: cenz,
    chain: chain,
    chat: chat,
    chips: chips,
    chsb: chsb,
    chz: chz,
    cix: cix,
    clam: clam,
    cloak: cloak,
    cmm: cmm,
    cmt: cmt,
    cnd: cnd,
    cnx: cnx,
    cny: cny,
    cob: cob,
    colx: colx,
    comp: comp,
    coqui: coqui,
    cred: cred,
    crpt: crpt,
    crv: crv,
    crw: crw,
    cs: cs,
    ctr: ctr,
    ctxc: ctxc,
    cvc: cvc,
    d: d,
    dai: dai,
    dash: dash,
    dat: dat,
    data: data,
    dbc: dbc,
    dcn: dcn,
    dcr: dcr,
    deez: deez,
    dent: dent,
    dew: dew,
    dgb: dgb,
    dgd: dgd,
    dlt: dlt,
    dnt: dnt,
    dock: dock,
    doge: doge,
    dot: dot,
    drgn: drgn,
    drop: drop,
    dta: dta,
    dth: dth,
    dtr: dtr,
    ebst: ebst,
    eca: eca,
    edg: edg,
    edo: edo,
    edoge: edoge,
    ela: ela,
    elec: elec,
    elf: elf,
    elix: elix,
    ella: ella,
    emb: emb,
    emc: emc,
    emc2: emc2,
    eng: eng,
    enj: enj,
    entrp: entrp,
    eon: eon,
    eop: eop,
    eos: eos,
    eqli: eqli,
    equa: equa,
    etc: etc,
    eth: eth,
    ethos: ethos,
    etn: etn,
    etp: etp,
    eur: eur,
    evx: evx,
    exmo: exmo,
    exp: exp,
    fair: fair,
    fct: fct,
    fida: fida,
    fil: fil,
    fjc: fjc,
    fldc: fldc,
    flo: flo,
    flux: flux,
    fsn: fsn,
    ftc: ftc,
    fuel: fuel,
    fun: fun,
    game: game,
    gas: gas,
    gbp: gbp,
    gbx: gbx,
    gbyte: gbyte,
    generic: generic,
    gin: gin,
    glxt: glxt,
    gmr: gmr,
    gmt: gmt,
    gno: gno,
    gnt: gnt,
    gold: gold,
    grc: grc,
    grin: grin,
    grs: grs,
    grt: grt,
    gsc: gsc,
    gto: gto,
    gup: gup,
    gusd: gusd,
    gvt: gvt,
    gxs: gxs,
    gzr: gzr,
    hight: hight,
    hns: hns,
    hodl: hodl,
    hot: hot,
    hpb: hpb,
    hsr: hsr,
    ht: ht,
    html: html,
    huc: huc,
    husd: husd,
    hush: hush,
    icn: icn,
    icp: icp,
    icx: icx,
    ignis: ignis,
    ilk: ilk,
    ink: ink,
    ins: ins,
    ion: ion,
    iop: iop,
    iost: iost,
    iotx: iotx,
    iq: iq,
    itc: itc,
    jnt: jnt,
    jpy: jpy,
    kcs: kcs,
    kin: kin,
    klown: klown,
    kmd: kmd,
    knc: knc,
    krb: krb,
    ksm: ksm,
    lbc: lbc,
    lend: lend,
    leo: leo,
    link: link,
    lkk: lkk,
    loom: loom,
    lpt: lpt,
    lrc: lrc,
    lsk: lsk,
    ltc: ltc,
    lun: lun,
    maid: maid,
    mana: mana,
    matic: matic,
    max: max,
    mcap: mcap,
    mco: mco,
    mda: mda,
    mds: mds,
    med: med,
    meetone: meetone,
    mft: mft,
    miota: miota,
    mith: mith,
    mkr: mkr,
    mln: mln,
    mnx: mnx,
    mnz: mnz,
    moac: moac,
    mod: mod,
    mona: mona,
    msr: msr,
    mth: mth,
    mtl: mtl,
    music: music,
    mzc: mzc,
    nano: nano,
    nas: nas,
    nav: nav,
    ncash: ncash,
    ndz: ndz,
    nebl: nebl,
    neo: neo,
    neos: neos,
    neu: neu,
    nexo: nexo,
    ngc: ngc,
    nio: nio,
    nkn: nkn,
    nlc2: nlc2,
    nlg: nlg,
    nmc: nmc,
    nmr: nmr,
    npxs: npxs,
    ntbc: ntbc,
    nuls: nuls,
    nxs: nxs,
    nxt: nxt,
    oax: oax,
    ok: ok,
    omg: omg,
    omni: omni,
    one: one,
    ong: ong,
    ont: ont,
    oot: oot,
    ost: ost,
    ox: ox,
    oxt: oxt,
    oxy: oxy,
    part: part,
    pasc: pasc,
    pasl: pasl,
    pax: pax,
    paxg: paxg,
    pay: pay,
    payx: payx,
    pink: pink,
    pirl: pirl,
    pivx: pivx,
    plr: plr,
    poa: poa,
    poe: poe,
    polis: polis,
    poly: poly,
    pot: pot,
    powr: powr,
    ppc: ppc,
    ppp: ppp,
    ppt: ppt,
    pre: pre,
    prl: prl,
    pungo: pungo,
    pura: pura,
    qash: qash,
    qiwi: qiwi,
    qlc: qlc,
    qnt: qnt,
    qrl: qrl,
    qsp: qsp,
    qtum: qtum,
    r: r,
    rads: rads,
    rap: rap,
    ray: ray,
    rcn: rcn,
    rdd: rdd,
    rdn: rdn,
    ren: ren,
    rep: rep,
    repv2: repv2,
    req: req,
    rhoc: rhoc,
    ric: ric,
    rise: rise,
    rlc: rlc,
    rpx: rpx,
    rub: rub,
    rvn: rvn,
    ryo: ryo,
    safe: safe,
    safemoon: safemoon,
    sai: sai,
    salt: salt,
    san: san,
    sand: sand,
    sbd: sbd,
    sberbank: sberbank,
    sc: sc,
    ser: ser,
    shift: shift,
    sib: sib,
    sin: sin,
    skl: skl,
    sky: sky,
    slr: slr,
    sls: sls,
    smart: smart,
    sngls: sngls,
    snm: snm,
    snt: snt,
    snx: snx,
    soc: soc,
    sol: sol,
    spacehbit: spacehbit,
    spank: spank,
    sphtx: sphtx,
    srn: srn,
    stak: stak,
    start: start,
    steem: steem,
    storj: storj,
    storm: storm,
    stox: stox,
    stq: stq,
    strat: strat,
    stx: stx,
    sub: sub,
    sumo: sumo,
    sushi: sushi,
    sys: sys,
    taas: taas,
    tau: tau,
    tbx: tbx,
    tel: tel,
    ten: ten,
    tern: tern,
    tgch: tgch,
    theta: theta,
    tix: tix,
    tkn: tkn,
    tks: tks,
    tnb: tnb,
    tnc: tnc,
    tnt: tnt,
    tomo: tomo,
    tpay: tpay,
    trig: trig,
    trtl: trtl,
    trx: trx,
    tusd: tusd,
    tzc: tzc,
    ubq: ubq,
    uma: uma,
    uni: uni,
    unity: unity,
    usd: usd,
    usdc: usdc,
    usdt: usdt,
    utk: utk,
    veri: veri,
    vet: vet,
    via: via,
    vib: vib,
    vibe: vibe,
    vivo: vivo,
    vrc: vrc,
    vrsc: vrsc,
    vtc: vtc,
    vtho: vtho,
    wabi: wabi,
    wan: wan,
    waves: waves,
    wax: wax,
    wbtc: wbtc,
    wgr: wgr,
    wicc: wicc,
    wings: wings,
    wpr: wpr,
    wtc: wtc,
    x: x,
    xas: xas,
    xbc: xbc,
    xbp: xbp,
    xby: xby,
    xcp: xcp,
    xdn: xdn,
    xem: xem,
    xin: xin,
    xlm: xlm,
    xmcc: xmcc,
    xmg: xmg,
    xmo: xmo,
    xmr: xmr,
    xmy: xmy,
    xp: xp,
    xpa: xpa,
    xpm: xpm,
    xpr: xpr,
    xrp: xrp,
    xsg: xsg,
    xtz: xtz,
    xuc: xuc,
    xvc: xvc,
    xvg: xvg,
    xzc: xzc,
    yfi: yfi,
    yoyow: yoyow,
    zcl: zcl,
    zec: zec,
    zel: zel,
    zen: zen,
    zest: zest,
    zil: zil,
    zilla: zilla,
    zrx: zrx,
    azn,
    kzt,
    mdl,
    uzs
};